// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1G3uE","sendOtp":"AuthorizeToLogin_sendOtp__11Zzn"};